"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMediaItems = exports.deleteMediaItem = exports.updateMediaItem = exports.addMediaItem = void 0;

var _antd = require("antd");

var _axios = _interopRequireDefault(require("axios"));

var _router = require("@reach/router");

var _ = require(".");

var _utils = require("../utils");

var _actions = require("../actions");

var addMediaItem = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, dispatch, config) {
    var siteID, file, user, formData, cleanedUrl, result, data, _err$response, _err$response$data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            siteID = _ref.siteID, file = _ref.file;
            user = _utils.auth.getUser(config);

            if (!(user !== null && user !== void 0 && user.authToken)) {
              _actions.authActions.signOut({
                callback: function callback() {
                  return (0, _router.navigate)('/');
                }
              }, dispatch, config);
            }

            _context.prev = 3;
            formData = new FormData();
            formData.append('file', file);
            cleanedUrl = config === null || config === void 0 ? void 0 : config.source.replace(/\/+$/, '');
            _context.next = 9;
            return _axios.default.post("".concat(cleanedUrl, "/wp-json/jamcms/v1/createMediaItem?siteID=").concat(siteID), formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: "Bearer ".concat(user.authToken)
              }
            });

          case 9:
            result = _context.sent;
            data = result.data;
            return _context.abrupt("return", data);

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](3);

            if (_context.t0 !== null && _context.t0 !== void 0 && (_err$response = _context.t0.response) !== null && _err$response !== void 0 && (_err$response$data = _err$response.data) !== null && _err$response$data !== void 0 && _err$response$data.message) {
              _antd.message.error(_context.t0.response.data.message);
            }

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 14]]);
  }));

  return function addMediaItem(_x, _x2, _x3) {
    return _ref5.apply(this, arguments);
  };
}();

exports.addMediaItem = addMediaItem;

var updateMediaItem = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2, dispatch, config) {
    var siteID, id, altText, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            siteID = _ref2.siteID, id = _ref2.id, altText = _ref2.altText;
            _context2.next = 3;
            return (0, _.db)('updateMediaItem', {
              siteID: siteID,
              id: id,
              altText: altText
            }, dispatch, config);

          case 3:
            result = _context2.sent;
            return _context2.abrupt("return", result);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function updateMediaItem(_x4, _x5, _x6) {
    return _ref6.apply(this, arguments);
  };
}();

exports.updateMediaItem = updateMediaItem;

var deleteMediaItem = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3, dispatch, config) {
    var siteID, id, result;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            siteID = _ref3.siteID, id = _ref3.id;
            _context3.next = 3;
            return (0, _.db)('deleteMediaItem', {
              siteID: siteID,
              id: id
            }, dispatch, config);

          case 3:
            result = _context3.sent;
            return _context3.abrupt("return", result);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function deleteMediaItem(_x7, _x8, _x9) {
    return _ref7.apply(this, arguments);
  };
}();

exports.deleteMediaItem = deleteMediaItem;

var getMediaItems = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref4, dispatch, config) {
    var siteID, _ref4$page, page, _ref4$limit, limit, result;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            siteID = _ref4.siteID, _ref4$page = _ref4.page, page = _ref4$page === void 0 ? null : _ref4$page, _ref4$limit = _ref4.limit, limit = _ref4$limit === void 0 ? 20 : _ref4$limit;
            _context4.next = 3;
            return (0, _.db)('getMediaItems', {
              siteID: siteID,
              page: page,
              limit: limit
            }, dispatch, config);

          case 3:
            result = _context4.sent;
            return _context4.abrupt("return", result);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getMediaItems(_x10, _x11, _x12) {
    return _ref8.apply(this, arguments);
  };
}();

exports.getMediaItems = getMediaItems;